import { Radio } from '@dixa/lib-shared-habla';
import { WrappedFieldProps } from 'redux-form';

type Props = WrappedFieldProps &
  Omit<React.ComponentProps<typeof Radio>, 'ref'>;

export function FieldRadio({ input, meta, ...radioProps }: Props): JSX.Element {
  return <Radio {...input} {...radioProps} />;
}
